import Gpt from '@op/components/GPT';
import { useGetSingePageSourceRule } from '@op/hooks/useGetPageSourceRule';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import CardCommon from '@op/components/CardCommon';
import { ScenarioType } from '../types';
export function useSplitGptSummary({
  filter,
  gameInfo,
  total = 0,
  hasAdvancedSummary = true,
  scenario,
  saveName,
}: {
  filter: any;
  gameInfo: any;
  total?: number;
  hasAdvancedSummary?: boolean;
  scenario?: ScenarioType;
  saveName?: string;
}) {
  const toggleVisibleRef = useRef<any>(null);
  const handleStopRef = useRef<any>(null);
  const [showAigcCard, setShowAigcCard] = useState(false);
  const [gptSuccess, setGptSuccess] = useState(false);
  const { GPT_Btn } = useGetSingePageSourceRule({ keys: 'GPT_Btn' });
  const [filterParams, setFilterParams] = useState();

  const gptFeedsStats = useMemo(() => {
    return { total };
  }, [total]);

  useEffect(() => {
    handleStopRef.current?.();
    setFilterParams({ ...filter, ...gameInfo });
  }, [filter, gameInfo]);

  const GptElement = useMemo(() => {
    return (
      <CardCommon
        className="dbo-aigc-card-wrapper"
        style={{ display: showAigcCard ? 'block' : 'none' }}
      >
        <Gpt.PageCard
          filter={filterParams}
          hasStopBtn={true}
          autoRequest={false}
          contentCard
          linkFilterChange={false}
          oriFeedsState={gptFeedsStats}
          className={'gpt-summary'}
          loadingHeight={160}
          saveName={saveName}
          scenario={scenario}
          hasAdvancedSummary={hasAdvancedSummary}
          stopAction={() => setShowAigcCard(false)}
          successAction={() => setGptSuccess(true)}
          promptConfirm={(data: { resultType: string }) => {
            if (data.resultType === 'page') {
              setGptSuccess(false);
              setShowAigcCard(true);
            }
          }}
        >
          {(
            toggleVisible: (arg0: boolean) => void,
            { total, handleStop }: any,
          ) => {
            toggleVisibleRef.current = toggleVisible;
            handleStopRef.current = handleStop;
            return (
              <Gpt.Button
                disabled={total <= 0}
                onClick={() => toggleVisible?.(true)}
              ></Gpt.Button>
            );
          }}
        </Gpt.PageCard>
      </CardCommon>
    );
  }, [filterParams, showAigcCard, gptFeedsStats]);

  const GptBtnElement = useMemo(() => {
    if (GPT_Btn) return null;
    return (
      <Gpt.Button
        disabled={
          (gptFeedsStats.total <= 0 && toggleVisibleRef.current) ||
          (showAigcCard && !gptSuccess)
        }
        onClick={() => {
          toggleVisibleRef.current?.(true);
        }}
      ></Gpt.Button>
    );
  }, [GPT_Btn, gptFeedsStats, showAigcCard, gptSuccess]);

  return {
    GptElement,
    GptBtnElement,
  };
}
